import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 h-full" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-red-500 mt-1 ml-1"
}

import RadioButton from '../RadioButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectableCard',
  props: {
    title: {},
    description: {},
    selected: { type: Boolean },
    error: { type: Boolean },
    errorMessage: {}
  },
  emits: ['click'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
      class: _normalizeClass(["p-4 border-2 rounded-lg shadow-sm bg-white text-sm w-full h-full leading-relaxed text-left cursor-pointer transition-all duration-200 ease-in-out hover:shadow-md flex flex-col gap-2", [
        _ctx.selected ? 'border-primary border-2' : 'border-gray-300 hover:border-primary-300',
        _ctx.error ? 'border-red-500' : ''
      ]])
    }, [
      _createVNode(RadioButton, {
        id: _ctx.title.replace(/\s+/g, '-').toLowerCase(),
        name: 'radio-group',
        value: _ctx.title,
        modelValue: _ctx.selected ? _ctx.title : '',
        "onUpdate:modelValue": () => {},
        label: ''
      }, null, 8, ["id", "value", "modelValue"]),
      _createElementVNode("div", null, [
        _createElementVNode("p", {
          class: _normalizeClass(['font-semibold mb-1 text-base', _ctx.error ? 'text-red-500' : 'text-gray-900'])
        }, _toDisplayString(_ctx.title), 3),
        _createElementVNode("p", {
          class: _normalizeClass(['text-sm', _ctx.error ? 'text-red-500' : 'text-gray-600'])
        }, _toDisplayString(_ctx.description), 3),
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})